import { downgradeComponent } from '@angular/upgrade/static';
import { downgradedAngularModule } from 'src/ajs-app/app';
import { TrackLinkLabelComponent } from './track-link-label/track-link-label.component';
import { TrackLinkLabelsComponent } from './track-link-labels.component';

downgradedAngularModule
  .directive('angularTrackLinkLabel', downgradeComponent({ component: TrackLinkLabelComponent }))
  .directive('angularTrackLinkLabels', downgradeComponent({ component: TrackLinkLabelsComponent }))
  ;

